<ui-section class="section-spacer-sample">
  <ui-block width="fill">
    <ui-panel panelTitle="EZ Form • Section Spacer Demo">
      <ui-form
        [config]="spacerDemoConfig">
      </ui-form>
    </ui-panel>
  </ui-block>

</ui-section>
